import PropTypes from 'prop-types'

const IndicatorOs = ({ razonSocial, cuit, periodo, children }) => {
  const hasPeriodo = Boolean(periodo)
  return (
    <>
      <div className="relative flex w-full justify-between items-end ">
        <div
          className={`nomina_div flex w-full  grid grid-cols-3     ${hasPeriodo ? 'grid-cols-3 ' : 'grid-cols-3 '}}`}
        >
          <div className="flex flex-col pl-6 py-3 border-l border-t border-b rounded-l-lg  ">
            <div className="text-left body2 text-tertiary-50">Razón social</div>
            <div className="text-left typography-b1 font-semibold text-primary-10">{razonSocial}</div>
          </div>

          <div
            className={`relative flex flex-col px-6 py-3 justify-center  border-t border-b   ${hasPeriodo ? '' : ' border-r rounded-br-lg'}`}
          >
            {/* linea */}
            <div className="absolute left-0 top-1/2 -translate-y-1/2 h-10 w-[1px]  bg-primary-10"></div>
            <div className="text-left body2 text-tertiary-50">CUIT</div>
            <div className="text-left typography-b1 font-semibold text-primary-10">{cuit}</div>
          </div>
          {periodo ? (
            <div
              className={`relative flex flex-col px-6 py-3 border-t border-b rounded-tr-lg ${hasPeriodo ? ' border-r rounded-br-lg' : ''}`}
            >
              <div className="absolute left-0 top-1/2 -translate-y-1/2 h-10 w-[1px]  bg-primary-10"></div>
              <div className="text-left body2 text-tertiary-50">Período fiscal</div>
              <div className="text-left typography-b1 font-semibold text-primary-10">{periodo}</div>
            </div>
          ) : (
            children
          )}
        </div>
      </div>
    </>
  )
}

IndicatorOs.propTypes = {
  razonSocial: PropTypes.string.isRequired,
  cuit: PropTypes.string.isRequired,
  periodo: PropTypes.string,
  children: PropTypes.node,
}

export default IndicatorOs
